import { render, staticRenderFns } from "./FDV.vue?vue&type=template&id=f1668cbc"
import script from "./FDV.vue?vue&type=script&lang=js"
export * from "./FDV.vue?vue&type=script&lang=js"
import style0 from "./FDV.vue?vue&type=style&index=0&id=f1668cbc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports